var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60091 1.7168H12.4009C13.1342 1.7168 13.7342 2.3168 13.7342 3.05013V4.5168C13.7342 5.05013 13.4009 5.7168 13.0676 6.05013L10.2009 8.58346C9.80091 8.9168 9.53424 9.58346 9.53424 10.1168V12.9835C9.53424 13.3835 9.26758 13.9168 8.93424 14.1168L8.00091 14.7168C7.13425 15.2501 5.93424 14.6501 5.93424 13.5835V10.0501C5.93424 9.58346 5.66758 8.98346 5.40091 8.65013L2.86758 5.98346C2.53424 5.65013 2.26758 5.05013 2.26758 4.65013V3.1168C2.26758 2.3168 2.86758 1.7168 3.60091 1.7168Z",
    stroke: "#ECEEF9",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconWhite);
export default __webpack_public_path__ + "static/media/filter-icon-white.98cf58d65e0cf6552166d16549b0d217.svg";
export { ForwardRef as ReactComponent };